import { IconButton, IconClose16, Spinner } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ChatPopup.css';

export interface IChatPopupProps {
  isOpen: boolean;
  src: string | null;
  onOpen?(): void;
  onClose(): void;
  className?: string;
}

export function ChatPopup({ isOpen, src, onClose, onOpen, className }: IChatPopupProps) {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  React.useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen, onOpen]);

  if (!isOpen || !src) {
    return null;
  }

  return (
    <div className={cn(styles['root'], className)} data-testid="ChatPopup">
      <span className={styles['close']}>
        <IconButton aria-label="Закрыть" icon={<IconClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe data-name="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
}
